import {
  GET_PAYMENT_METHODS,
} from "@actions/account/billing"
import { get, put } from "@api/fetch"

/**
 * Get payment methods
 * - retrieves the credit card and gift cards of the user/org
 * @returns dispatch
 */

export const getPaymentMethods = () => dispatch => dispatch(get(GET_PAYMENT_METHODS, "settings/paymentmethods"))

/**
 * Set default credit card
 * @returns dispatch
 */

export const updatePaymentMethod = (key, value) => (dispatch, getState) => {
  dispatch(
    put(GET_PAYMENT_METHODS, `settings/paymentmethods`, {
      key: key,
      value: value
    })
  )
}